import { ValidationItems, makeIsAllowed } from '@kanda-libs/ks-component-ts';

export const RESIDENTIAL_STATUS_OWNER = ['owner', 'owner_without_mortgage'];

export const RESIDENTIAL_PROPS = {
  residentialStatusProps: {
    placeholder: 'Select...',
  },
  monthlyRentProps: {
    label: 'Monthly rent',
    placeholder: 'Your monthly rent',
    type: 'price',
    icon: 'pound',
    iconVariant: 'dark',
    isAllowed: makeIsAllowed(0, 100000),
    symbol: '',
  },
  monthlyMortgageProps: {
    label: 'Monthly mortgage',
    placeholder: 'Your monthly mortgage',
    type: 'price',
    icon: 'pound',
    iconVariant: 'dark',
    isAllowed: makeIsAllowed(0, 100000),
    symbol: '',
    name: 'monthly_mortgage_amount',
  },
};

export const MORTGAGE_VALIDATION: ValidationItems = {
  required: { value: true, message: 'Amount is required.' },
  min: { value: 0, message: 'Amount must be great than 0' },
  max: {
    value: 2147483647,
    message: 'Amount must be smaller than 2.147483647e+09',
  },
};
